/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "headerHash",
                type: "bytes32",
            },
        ],
        name: "HeaderDataInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "headerHash",
                type: "bytes32",
            },
        ],
        name: "HeaderNotFound",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "headerRlpBytes",
                type: "bytes",
            },
        ],
        name: "add",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "transactionRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "receiptsRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "stateRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "blockTimestamp",
                        type: "uint256",
                    },
                ],
                internalType: "struct HeaderCache.Header",
                name: "header",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "headerHash",
                type: "bytes32",
            },
        ],
        name: "exists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "rlpBytes",
                type: "bytes",
            },
        ],
        name: "extractHeader",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "transactionRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "receiptsRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "stateRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "blockTimestamp",
                        type: "uint256",
                    },
                ],
                internalType: "struct HeaderCache.Header",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "headerHash",
                type: "bytes32",
            },
        ],
        name: "get",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "transactionRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "receiptsRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "stateRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "blockTimestamp",
                        type: "uint256",
                    },
                ],
                internalType: "struct HeaderCache.Header",
                name: "header",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class HeaderCache__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
HeaderCache__factory.bytecode = _bytecode;
HeaderCache__factory.abi = _abi;
//# sourceMappingURL=HeaderCache__factory.js.map